/* eslint-disable no-undef */
import React, { useEffect } from 'react';
import { Helmet } from "react-helmet-async";
import FooterTwo from '../../components/Footer/FooterTwo';
import HeaderFour from '../../components/Header/HeaderFour';

import Logo from '../../assets/img/logo/logo-white-5.png';
// import { Link } from 'react-router-dom';
// import { Swiper, SwiperSlide } from 'swiper/react';
// import { Autoplay, Navigation } from 'swiper/modules';
import Breadcrumb from '../../components/Breadcrumb';
// import RightArrow from '../../components/SVG';
// import SingleProgress from '../../components/Progress';
import SectionTitle from '../../components/SectionTitle';
// import SingleTeamThree from '../../components/Team/SingleTeamThree';
// import NextArrow from '../../components/SVG/NextArrow';
// import PrevArrow from '../../components/SVG/PrevArrow';

// import teamMainImg from '../../assets/img/team/team-inner.jpg';
// import teamImg1 from '../../assets/img/team/team-4-1.jpg';
// import teamImg2 from '../../assets/img/team/team-4-2.jpg';
// import teamImg3 from '../../assets/img/team/team-4-3.jpg';
// import teamImg4 from '../../assets/img/team/team-4-4.jpg';
// import teamImg5 from '../../assets/img/team/team-4-5.jpg';
// import teamImg6 from '../../assets/img/team/team-4-6.jpg';

const Careers = () => {
  useEffect(() => {
      const script = document.createElement('script');
      script.src = 'https://tally.so/widgets/embed.js';
      script.async = true;
      document.body.appendChild(script);
    }, []);
  // const sliderOption = {
  //   speed: 1500,
  //   loop: true,
  //   slidesPerView: '4',
  //   spaceBetween: 50,
  //   autoplay: {
  //     delay: 5000,
  //   },
  //   breakpoints: {
  //     1400: {
  //       slidesPerView: 4,
  //     },
  //     992: {
  //       slidesPerView: 3,
  //       spaceBetween: 30,
  //     },
  //     768: {
  //       slidesPerView: 2,
  //       spaceBetween: 30,
  //     },
  //     0: {
  //       slidesPerView: 1,
  //     },
  //   },
  //   navigation: {
  //     prevEl: '.slider-prev',
  //     nextEl: '.slider-next',
  //   },
  // };
  useEffect(() => {
      window.$('select').niceSelect();
    }, []);
  return (
    <main>
      <Helmet>
        <meta charSet="utf-8" />
        {/* OLD TITLE COMMENTED */}
        {/* <title>Careers at Central Books | Join Our Team</title> */}
        <title>Careers at CBS HUB Central Books Hyderabad | Join Our Team</title>
        {/* OLD DESCRIPTION COMMENTED */}
        {/* <meta name="description" content="Explore career opportunities at Central Books and become part of a dynamic team that is shaping the future of education. We are looking for passionate individuals to join us in our mission." /> */}

        <meta name="description" content="Explore career opportunities at CBS HUB Private Limited (Central Books), Hyderabad. Join 250+ education professionals shaping school supply for 450+ schools across India." />
        <meta name="keywords" content="careers Central Books Hyderabad, jobs CBS HUB, education industry jobs Hyderabad, school supply company careers" />
        <meta name="robots" content="index, follow" />
        <meta name="author" content="Central Books" />
        <meta httpEquiv="content-language" content="en" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="canonical" href="https://www.centralbooks.in/careers" />
        <meta property="og:title" content="Careers at CBS HUB Central Books Hyderabad | Join Our Team" />
        <meta property="og:description" content="Explore career opportunities at CBS HUB Private Limited (Central Books), Hyderabad. Join 250+ education professionals shaping school supply for 450+ schools across India." />
        {/* OLD IMAGE COMMENTED */}
        {/* <meta property="og:image" content="https://www.centralbooks.in/images/careers-banner.jpg" /> */}
        <meta property="og:image" content="https://www.centralbooks.in/images/careers-og.jpg" />
        <meta property="og:url" content="https://www.centralbooks.in/careers" />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Central Books" />
        <meta property="og:locale" content="en_IN" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Careers at CBS HUB Central Books Hyderabad | Join Our Team" />
        <meta name="twitter:description" content="Explore career opportunities at CBS HUB Private Limited (Central Books), Hyderabad. Join 250+ education professionals shaping school supply for 450+ schools across India." />
        <meta name="twitter:image" content="https://www.centralbooks.in/images/careers-og.jpg" />
        {/* EXISTING ORGANIZATION SCHEMA KEPT */}
        <script type="application/ld+json">{JSON.stringify({"@context":"https://schema.org","@type": "Organization",name:"Central Books",url:"https://www.centralbooks.in/careers",logo:"https://centralbooks.in/static/media/logo-white.6970e86702604974eb88.png",})}
        </script>

        {/* NEW BREADCRUMB SCHEMA */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            itemListElement: [
              {
                "@type": "ListItem",
                position: 1,
                name: "Home",
                item: "https://www.centralbooks.in/",
              },
              {
                "@type": "ListItem",
                position: 2,
                name: "Careers",
                item: "https://www.centralbooks.in/careers",
              },
            ],
          })}
        </script>

        {/* NEW JOB POSTING SCHEMA */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "JobPosting",
            hiringOrganization: {
              "@type": "Organization",
              name: "CBS HUB Private Limited",
              sameAs: "https://www.centralbooks.in",
            },
            jobLocation: {
              "@type": "Place",
              address: {
                "@type": "PostalAddress",
                addressLocality: "Hyderabad",
                addressRegion: "Telangana",
                addressCountry: "IN",
              },
            },
            title: "Multiple Roles",
            datePosted: "2025-01-01",
            validThrough: "2025-12-31",
          })}
        </script>
      </Helmet>
      <HeaderFour />
      <Breadcrumb title="Careers" subTitle="Careers" />
      <div className="it-teacher-details-area pt-10 pb-10">
        <div className="container">
          <div className="it-teacher-details-wrap">
            <div className="row">
              <div className="col-xl-12 col-lg-12">
                <div className="it-teacher-details-right">
                  <div className="it-teacher-details-right-title-box">
                    <h4>Working At CENTRAL BOOKS</h4>
                    <span>Come and Join Us!</span>
                    <p>
                    A culture of innovation at the heart
                    of satisfaction.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="ed-team-area grey-bg-5 p-relative inner-style fix z-index pt-110 pb-120">
        <div className="container">
          <div className="it-team-title-wrap mb-40">
            <div className="row align-items-center justify-content-center">
              <div className="col-xl-12">
                <SectionTitle
                  itemClass="it-team-title-box text-center"
                  subTitleClass="ed-section-subtitle"
                  subTitle="Submit Your Resume"
                  titleClass="ed-section-title"
                  title="Ask Us for Current Openings & Submit Your Resume here"
                />
              </div>
              <div className="it-student-regiform">
                  <h4 className="it-student-regiform-title">
                  Submit Your Resume here
                  </h4>
                  <div className="container mt-4">
                    <iframe
                      data-tally-src="https://tally.so/embed/nW1Z0P?alignLeft=1&hideTitle=1&transparentBackground=1"
                      loading="lazy"
                      width="100%"
                      height="669"
                      frameBorder="0"
                      marginHeight="0"
                      marginWidth="0"
                      title="Careers"
                      style={{
                        borderRadius: "5px",
                        padding: "15px",
                        marginBottom: "20px",
                        width: "100%",
                      }}
                    ></iframe>
                  </div>
                </div>
            </div>
          </div>
        </div>
      </div>
      <FooterTwo
        footerClass="it-footer-area it-footer-bg it-footer-style-5 ed-footer-style-5 black-bg pb-70"
        footerLogo={Logo}
        btnClass="it-btn-white sky-bg"
      />
    </main>
  );
};
export default Careers;
